/* No sample events. Purchases require a separate, privacy-filtered server feed. */
(() => {
  'use strict';
  const HOUR = 3600000;
  const text = (v, max = 180) => typeof v === 'string' && v.trim().length > 0 && v.length <= max && !/[<>\x00-\x1f]/.test(v) ? v.trim() : null;
  function product(v, origin) {
    if (!v || !text(v.title)) return null;
if (/\bclearance\b/i.test(v.title + ' ' + (v.url || ''))) return null;
    try {
      const url = new URL(v.url, origin), image = new URL(v.image, origin);
      if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname) || url.search || url.hash) return null;
      if (image.protocol !== 'https:' || image.username || image.password || !(image.hostname === 'cdn.shopify.com' || image.origin === origin) || !/\/(?:files|products)\//.test(image.pathname)) return null;
      return {title: text(v.title), url: url.href, image: image.href};
    } catch (_) { return null; }
  }
  function feed(payload, now, origin) {
    if (!payload || payload.contractVersion !== 2 || payload.status !== 'verified' || !Array.isArray(payload.events)) return [];
    const generated = Date.parse(payload.generatedAt), expires = Date.parse(payload.expiresAt);
    if (!Number.isFinite(generated) || !Number.isFinite(expires) || generated > now + 60000 || now - generated > 10 * 60000 || expires <= now || expires - generated > 10 * 60000) return [];
    const seen = new Set();
    return payload.events.slice(0, 30).flatMap(event => {
      const p = product(event.product, origin), at = Date.parse(event.purchasedAtHour);
      const state = text(event.state, 45), city = event.city ? text(event.city, 60) : '';
      if (!p || event.product.publiclyListed !== true || event.product.kind !== 'door_cover' || !/^[a-f0-9]{32,64}$/.test(event.id || '') || seen.has(event.id) || !state || !city || /[0-9@/\\:]/.test(state + city) || event.timePrecision !== 'hour' || !Number.isFinite(at) || at % HOUR !== 0 || now - at < HOUR || now - at > 7 * 24 * HOUR) return [];
      seen.add(event.id);
      return [{...p, location: [city, state].filter(Boolean).join(', '), purchase: true}];
    });
  }
  /* Export only in the isolated local test harness. No customer data is exported. */
  if (typeof module !== 'undefined' && module.exports) { module.exports = {product, feed}; return; }
  const controllers = new Map();
  function start(root) {
    if (controllers.has(root)) return;
    let cfg, raw;
    try { cfg = JSON.parse(root.querySelector('[data-proof-config]').textContent); raw = JSON.parse(root.querySelector('[data-proof-products]').textContent); } catch (_) { return; }
    const card = root.querySelector('[data-proof-card]'), close = root.querySelector('[data-proof-close]');
    const get = name => root.querySelector(`[data-proof-${name}]`);
    if (!card || !close) return;
    document.body.classList.add('dyd-proof-lane');
    document.body.classList.toggle('dyd-proof-christmas', root.dataset.season === 'christmas');
    const unique = new Map();
    (Array.isArray(raw) ? raw : []).forEach(v => { const p = product(v, location.origin); if (p) unique.set(p.url, p); });
    let items = [...unique.values()], index = 0, count = 0, stopped = false, timer, hideTimer, disposed = false;
    try { stopped = sessionStorage.getItem('dydProofClosed') === 'true'; } catch (_) { /* Private browsing: in-memory dismissal still works. */ }
    const bounded = (v, fallback, min, max) => Math.max(min, Math.min(max, Number(v) || fallback));
    const duration = bounded(cfg.duration, 7000, 5000, 12000), interval = bounded(cfg.interval, 30000, 20000, 60000);
    function hide() { if (card.contains(document.activeElement)) return; card.hidden = true; }
    function obstructed() {
      return [...document.querySelectorAll('.dyd-gift-overlay.is-open, dialog[open], [role="dialog"][aria-modal="true"]')].some(el => el.getAttribute('aria-hidden') !== 'true' && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length > 0) || (window.visualViewport && window.visualViewport.height < window.innerHeight * .72);
    }
    function sync() {
      const blocked = obstructed();
      document.body.classList.toggle('dyd-proof-obscured', !!blocked);
      if (blocked || document.hidden) hide();
    }
    function show() {
      if (disposed || stopped || count >= 3) return;
      sync();
      if (!document.hidden && !obstructed() && items.length && !card.contains(document.activeElement)) {
        const item = items[index++ % items.length]; count++;
        get('heading').textContent = item.purchase ? cfg.purchaseHeading : cfg.catalogHeading;
        get('location').textContent = item.purchase ? `${cfg.locationPrefix} ${item.location}` : '';
        get('location').hidden = !item.purchase;
        get('title').textContent = item.title; get('title').href = item.url;
        get('image-link').href = item.url; get('image').src = item.image;
        get('detail').textContent = item.purchase ? cfg.recentLabel : cfg.trust;
        card.hidden = false;
        clearTimeout(hideTimer); hideTimer = setTimeout(hide, duration);
      }
      timer = setTimeout(show, interval);
    }
    function dismiss() {
      stopped = true; card.hidden = true; clearTimeout(timer); clearTimeout(hideTimer);
      try { sessionStorage.setItem('dydProofClosed', 'true'); } catch (_) {}
      root.setAttribute('tabindex', '-1'); root.focus({preventScroll: true});
    }
    close.addEventListener('click', dismiss);
    card.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); dismiss(); } });
    card.addEventListener('focusout', () => { clearTimeout(hideTimer); hideTimer = setTimeout(hide, duration); });
    const observer = new MutationObserver(sync);
    observer.observe(document.body, {attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden', 'open']});
    document.addEventListener('visibilitychange', sync);
    window.visualViewport?.addEventListener('resize', sync);
    const abort = new AbortController();
    if (cfg.enabled === true) {
      try {
        const endpoint = new URL(cfg.endpoint, location.origin);
        if (endpoint.origin === location.origin && endpoint.pathname === '/apps/dyd-studio' && endpoint.searchParams.get('action') === 'purchase-feed') {
          const timeout = setTimeout(() => abort.abort(), 4000);
          fetch(endpoint.href, {credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: {'Accept': 'application/json'}})
            .then(response => response.ok && (response.headers.get('content-type') || '').includes('application/json') ? response.json() : null)
            .then(data => { const verified = feed(data, Date.now(), location.origin); if (verified.length && !disposed) items = verified; })
            .catch(() => {}).finally(() => clearTimeout(timeout));
        }
      } catch (_) { /* Remain an honestly labeled catalog card. */ }
    }
    timer = setTimeout(show, bounded(cfg.initialDelay, 8000, 5000, 30000)); sync();
    controllers.set(root, () => { disposed = true; clearTimeout(timer); clearTimeout(hideTimer); abort.abort(); observer.disconnect(); document.removeEventListener('visibilitychange', sync); window.visualViewport?.removeEventListener('resize', sync); controllers.delete(root); if (!controllers.size) document.body.classList.remove('dyd-proof-lane', 'dyd-proof-christmas', 'dyd-proof-obscured'); });
  }
  document.querySelectorAll('[data-dyd-proof-2026]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dyd-proof-2026]').forEach(start));
  document.addEventListener('shopify:section:unload', event => { for (const [root, stop] of controllers) if (event.target.contains(root)) stop(); });
})();